module.exports = "/images/award-badge.svg?ae8c38fbab68c54a24246eed193d72ca";